import loadable from '@loadable/component'

export const SustainableFitchHighlight = loadable(
  () => import('./SustainableFitchHighlight')
)
export const SustainableFitchHighlightVideo = loadable(
  () => import('./SustainableFitchHighlightVideo')
)
export const SustainableFitchHighlights = loadable(
  () => import('./SustainableFitchHighlights')
)
export const SustainableFitchHighlightText = loadable(
  () => import('./SustainableFitchHighlightText')
)
export type { SustainableFitchHighlightProps } from './SustainableFitchHighlight'
export type { SustainableFitchHighlightTextProps } from './SustainableFitchHighlightText'
export type { HighlightVideoProps } from './SustainableFitchHighlightVideo'
export type { SustainableFitchHighlightsProps } from './SustainableFitchHighlights'
